import { Button, Card, Col, Form, Row } from 'antd';
import Papa from 'papaparse';
import { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import { Link, useHistory } from 'react-router-dom';
import { FileExcelFilled } from '@ant-design/icons';
import { AttendanceService } from '@gtpl/shared-services/hrms';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Excel } from 'antd-table-saveas-excel';
import React from 'react';
import moment from 'moment';

export const AttendanceExcel = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const service = new AttendanceService();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const fileInputRef = useRef(null); 

  const importExcel = (file: any[]) => {
    var data = new Uint8Array(file);
    var wb = XLSX.read(data, { type: 'array', cellDates: true });
    let sheet: any[] = [];
    for (const Sheet in wb.Sheets) {
      if (Sheet) {
        if (wb.Sheets.hasOwnProperty(Sheet)) {
          sheet.push(
            XLSX.utils.sheet_to_json(wb.Sheets[Sheet], { raw: true, header: 1 })
          );
        }
      }
    }
    return sheet;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(event.target.files[0]);
      Papa.parse(event.target.files[0], {
        header: true,
        complete: function (result) {
          {
            const columnArray = [];
            const valueArray = [];

            result.data.map((d) => {
              columnArray.push(Object.keys(d));
              valueArray.push(Object.values(d));
            });
            setData(result.data);
            // setColumns(columnArray[0]);
            // setValues(valueArray);
          }
        },
        skipEmptyLines: true,
      });
    } else {
      alert('Please select a valid .csv.');
      setSelectedFile(null);
    }
  };

  const handleUpload = async () => {
    try {
      form.validateFields().then(async () => {
        const res = await service.attendanceUpload(data);

        if (res.status) {
          if (res.data.status == true) {
            AlertMessages.getSuccessMessage(res.data.internalMessage);
            setSelectedFile(null);
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
          } else {
            AlertMessages.getErrorMessage(res.data.internalMessage);
          }
        } else {
          AlertMessages.getErrorMessage(res.data.internalMessage);
        }
      });
    } catch (error) {
      AlertMessages.getErrorMessage(error.message);
    }
  };

  const excelColumns = [
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      formatter: (value) => {
        if (value) {
          return moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
        return value;
      },
    },
    {
      title: 'Shift',
      dataIndex: 'shift'
    },
    {
      title: 'In Time',
      dataIndex: 'inTime',
      formatter: (value) => {
        if (value) {
          return moment(value, 'YYYY-MM-DD HH:mm:ss').format(
            'YYYY-MM-DD HH:mm:ss'
          );
        }
        return value;
      },
    },
    {
      title: 'Out Time',
      dataIndex: 'outTime',
      formatter: (value) => {
        if (value) {
          return moment(value, 'YYYY-MM-DD HH:mm:ss').format(
            'YYYY-MM-DD HH:mm:ss'
          );
        }
        return value;
      },
    },
  ];

  const excelData = [
    {
      employeeCode: 'XYZ',
      date: '20-08-2024',
      shift: 'Should be between A-E',
      inTime: '2024-08-20 09:00:00',
      outTime: '2024-08-20 18:00:00',
    },
  ];

  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('Attendance')
      .addColumns(excelColumns)
      .addDataSource(excelData)
      .saveAs('Attendance-Upload.xlsx');
  };

  return (
    <Card
      title="Attendance Upload"
      extra={
        <span style={{ color: 'white' }}>
          <Button
            type="default"
            style={{ color: 'green' }}
            onClick={exportExcel}
            icon={<FileExcelFilled />}
          >
            Sample Format
          </Button>
        </span>
      }
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <Form layout="horizontal">
        <Row gutter={24}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <Form.Item label="Upload Excel">
              <input
                placeholder="Upload Excel"
                type="file"
                accept=".csv"
                onChange={handleFileChange}
              />
              <label style={{ color: 'blue', whiteSpace: 'nowrap' }}>
                Only csv
              </label>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <Button
              type="primary"
              onClick={handleUpload}
              loading={loading}
              disabled={!selectedFile}
            >
              Upload
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default AttendanceExcel;
